import { Abstrap } from '../..';

const { propTypes } = Abstrap;

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'span',
    title: '',
};

class TabMenuSubtitle extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-tab-menu__subtitle',
            className,
        ];
    }

}

TabMenuSubtitle.propTypes = propTypes;

TabMenuSubtitle.defaultProps = defaultProps;

export default TabMenuSubtitle;
